export const APPLICATION_AUTH_CONTENT = {
  initialTitle: 'Apply today.',
  initialDescription: 'Take a step toward your future.',
  emailLabel: 'Email address',
  applicationPageEmailLabel: 'Email Address',
  emailPlaceholder: 'you@example.com',
  ssoDivider: 'or use your email',
  continueDescription:
    "Enter the email address you gave us when you started the application and we'll pull it right up.",
  continueSsoDescription:
    "Sign in the same way you started your application and we'll pull it right up.",
  consentPrefix:
    'By starting your application, you give consent to Campus to contact you by email, phone, or text message with information about Campus programs as described in the',
  termsLabel: 'Terms and Conditions',
  privacyLabel: 'Privacy Policy',
  confirmationTitle: 'Check your inbox — your application link is on its way!',
  confirmationPrefix:
    "Didn't get the email? Check your spam folder, or email us at",
  admissionsEmail: 'admissions@campus.edu',
} as const
